"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import { useState, useEffect } from "react";
import gradImg from "@/assets/graduation.png";
import chartImg from "@/assets/chart.png";
import serverImg from "@/assets/server.png";
import Link from "next/link";
import Title from "../Title";
import { ArrowRight } from "lucide-react";
import { time } from "framer-motion";

const blogs = [
  {
    image: gradImg,
    tag: "International",
    title:
      "CBSE Board Class 12 Result 2025: A Milestone Moment & The Road Ahead",
    description:
      "As per the report of Praxis Global Alliance, the diagnostic industry in India is projected to reach...",
    author: "Sayani haldar",
    date: "Sep 9, 2024",
    readTime: "7 min read",
  },
  {
    image: chartImg,
    tag: "MSU",
    title:
      "CBSE Board Class 12 Result 2025: A Milestone Moment & The Road Ahead",
    description:
      "As per the report of Praxis Global Alliance, the diagnostic industry in India is projected to reach...",
    author: "Sayani haldar",
    date: "Sep 9, 2024",
    readTime: "7 min read",
  },
  {
    image: serverImg,
    tag: "International",
    title:
      "CBSE Board Class 12 Result 2025: A Milestone Moment & The Road Ahead",
    description:
      "As per the report of Praxis Global Alliance, the diagnostic industry in India is projected to reach...",
    author: "Sayani haldar",
    date: "Sep 9, 2024",
    readTime: "7 min read",
  },
];

const BlogList = ({ data }) => {
  // const [randomBlogs, setRandomBlogs] = useState([]);

  // const getRandomBlogs = (blogs, count = 3) =>
  //   [...blogs].sort(() => 0.5 - Math.random()).slice(0, count);

  // useEffect(() => {
  //   if (Array.isArray(data) && data.length > 0) {
  //     setRandomBlogs(getRandomBlogs(data, 3));
  //   }
  // }, [data]);

  return (
    // <section className="page-container top_bottom_space">
    //   <div className="w-full heading_space_bottom">
    //     <Title
    //       heading={"Explore Our Blogs"}
    //       subText={
    //         "Explore stories, ideas, and perspectives from the heart of Medhavi Skills University, where education meets experience and every skill tells a story"
    //       }
    //       color="text-black"
    //       subTextColor="text-black"
    //       align="text-left"
    //     />
    //   </div>
    //   <div className="w-full mx-auto">
    //     <Swiper
    //       modules={[Autoplay]}
    //       spaceBetween={16}
    //       slidesPerView={1.2}
    //       loop={true}
    //       autoplay={{
    //         delay: 2000,
    //         disableOnInteraction: false,
    //       }}
    //       breakpoints={{
    //         640: { slidesPerView: 1.5 },
    //         768: { slidesPerView: 2 },
    //         1024: { slidesPerView: 2.5 },
    //         1280: { slidesPerView: 3 },
    //       }}
    //       className="blogs w-full"
    //     >
    //       {randomBlogs.map((item, index) => (
    //         <SwiperSlide key={index} className="pb-2">
    //           <div className="flex flex-col bg-white overflow-hidden transition duration-300">
    //             <div className="relative w-full h-55 sm:h-65 md:h-68 lg:h-75  overflow-hidden">
    //               <Image
    //                 src={item.cover.formats?.small?.url}
    //                 alt={item.title}
    //                 fill
    //                 className="object-cover w-full  h-55 sm:h-65 md:h-68 lg:h-75 transition-transform duration-500 hover:scale-110"
    //               />
    //             </div>

    //             <Link
    //               href={`/blog/${item.slug}`}
    //               className="py-5 flex flex-col gap-2 px-2"
    //             >
    //               <span className="text-xs font-bold bg-[#FFF0D7] text-[#EB9100] px-2 py-1 uppercase w-fit">
    //                 {item.category?.name}
    //               </span>

    //               <span className="line-clamp-2 text-[18px] lg:[20px] font-bold text-gray-900 leading-snug hover:text-[#EB9100] cursor-pointer">
    //                 {item.title}
    //               </span>

    //               <p className="text-[16px] text-gray-600 line-clamp-2">
    //                 {item.description}
    //               </p>

    //               <hr className="mt-3 border-t border-[#616777]/20 border-[1px] w-full" />

    //               <div className="flex items-center text-[clamp(10px,9.5vw,12px)] md:text-[13px] text-gray-500 gap-3">
    //                 <span>{item.author?.name}</span>

    //                 <span className="flex items-center gap-1">
    //                   <span className="text-[20px] font-bold">·</span>
    //                   {new Date(item.blogDate).toDateString()}
    //                 </span>

    //                 <span className="flex items-center gap-1">
    //                   <span className="text-[20px] font-bold">·</span>2 min
    //                 </span>
    //               </div>
    //             </Link>
    //           </div>
    //         </SwiperSlide>
    //       ))}
    //     </Swiper>

    //     <div className="w-full flex justify-center mt-10">
    //       <Link
    //         href={"/blog"}
    //         className="cursor-pointer flex items-center gap-2 text-[16px] font-semibold text-black"
    //       >
    //         <span className="text-lg">Discover all blogs</span>
    //         <div className="bg-black text-lg p-1 transition flex items-center justify-center">
    //           <span className="text-white  material-symbols-outlined">
    //             <ArrowRight />
    //           </span>
    //         </div>
    //       </Link>
    //     </div>
    //   </div>
    // </section>
  <></>
  );
};

export default BlogList;
